import React, { useState, useEffect } from "react";
import NavBarMain from "./NavBarMain";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import axios from ".././axios-interceptor";
import { base_url, COMPLIANCE_APPROVED, LOAN_CURRENCY_TYPE_USD} from "../utilities";
import {  Link, useNavigate } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import "react-toastify/dist/ReactToastify.css";
import ApplyNewLoan from './ApplyNewLoan';
import NewServiceRequest from "./NewServiceRequest";
import SideNavBar from './SideNavBar';
import KYCDocumentsModal from './KYCDocumentsModel';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import ProgressBar from "@ramonak/react-progress-bar";
import moment from "moment";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;

const BusinessDashboard = (props) => {
  
  useEffect(()=>{
    if (Cookies.get("User_Accesstoken_Business") == null) {
      navigate('/');
    }
  },[])
  const navigate = useNavigate();
  ChartJS.register(...registerables);
  const [dashBoardData, setDashBoardData] = useState([])
  const [modalShow, setModalShow] = React.useState(false);
  const [show, setShow] = React.useState(false)
  const [showuploadKYC, setModalShowUploadKYC] = React.useState(false)
  const [businessdataUser, setBusinessdataUser] = useState([]);

  const [chart_loaded, setChartLoaded] = React.useState(false);
  const [chartData, setChartData] = useState();
  const [loading, setLoading] = useState(true);
  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }

  
  useEffect(() => {
    disableBackButton();
   
    axios
      .post(base_url + "business-master/get_business_data_user", {
        user_id: Cookies.get("user_id"), 
      })
      .then((res) => {

        // if(res.data.data[0].status!=COMPLIANCE_APPROVED){
        //   navigate('/kycform')
        // }else{
        //   navigate('/businessdashboard')

        // }
        Cookies.set("business_id", res.data.data?.business_id, { expires: 7 })
        setBusinessdataUser(res.data.data);
        axios
          .post(base_url + "business-master/get_business_dashboard", {
            business_id: res.data.data?.business_id,
          })
          .then((res) => {
            let myDynamicArray = []
            let backgroundColor = ["#0A369D", "#4472CA", "#5E7CE2", '#92B4F4', '#F4CD2A', '#A6A6A6', '#12245A']
            res.data.data.type_of_facility?.map((i, index) => {
              backgroundColor.map((color, id) => {
                if (index == id) {
                  i.color_idx = color;
                }
              });
            })
            setDashBoardData(res.data.data);
            res.data.data.type_of_facility?.map((i, index) => {
              if (i.percentage !== '' || i.percentage !== undefined) {
                myDynamicArray.push(Number(i.percentage))
              }
            });
            setChartData({
              datasets: [
                {
                  data: myDynamicArray,
                  backgroundColor: backgroundColor,
                  hoverOffset: 10,
                },
              ],
            })
            setChartLoaded(true);
            setLoading(false)
          })
          .catch((err) => {
            alert("error")
            console.log(err,"error");
          });

      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Business");
          Cookies.remove("User_Refreshtoken_Business");
          navigate("/");
        }
      });

  }, []);
  let totalAmountin_USD = 0;
  let totalAmountin_BHD = 0;

  dashBoardData.current_outstanding?.forEach(i => {
    if (Number(i.total_outstanding_principal_bhd_type)) {
      totalAmountin_BHD = totalAmountin_BHD + Number(i.total_outstanding_principal_bhd_type)
    }
    if (Number(i.total_outstanding_principal_usd_type)) {
      totalAmountin_USD = totalAmountin_USD + Number(i.total_outstanding_principal_usd_type)
    }
  })

  const columns = [
    {
      title: "Reference",
      field: "transaction_reference_no",
    },
    {
      title: "Amount",
      field: "paid_amount",

    },
    {
      title: "Due Date",
      field: "due_date",
    },
    {
      title: "Value Date",
      field: "paid_date",
    },
    {
      title: "Description",
      field: "Description",
    },

  ];

  let progress_usd = (Math.ceil(Number(dashBoardData.total_principal_repaid_usd / dashBoardData.total_loan_amount_usd) * 100))
  let progress_bhd = (Math.ceil(Number(dashBoardData.total_principal_repaid_bhd / dashBoardData.total_loan_amount_bhd) * 100))

  if (Cookies.get("user_id") !== null || Cookies.get("user_id") !== undefined) {
    return (
      <div style={{ display: "flex", height: "100vh" }}>
        <SideNavBar status={businessdataUser?.onboard_status}/>
        <main style={{ width: "100%" }}>
          <NavBarMain
            businessname={
              businessdataUser.business_name === undefined
                ? ""
                : businessdataUser.business_name || <Skeleton count={1} />
            }
          />

          {loading ? (
            <div>
              <div>
                <Skeleton
                  width={1040}
                  height={150}
                  count={1}
                  className="skeleton_mrgn"
                />
              </div>
              <div className="d-flex gap-5 ">
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={`content_main_body db_body `}>
              <div className="row d-flex justify-content-between mb-2 db_media_scrn">
                <div className="col d-flex justify-content-between justify-content-lg-start align-items-center  ">
                  <h1 className="mb-0 me-lg-4 me-0 business_db_title">
                    {" "}
                    Dashboard{" "} 
                  </h1>
                  <h3
                    className="pe-sm-2 uploadKYCDocBsnsDB"
                    onClick={() => setModalShowUploadKYC(true)}
                  >
                    Click Here to Upload KYC Documents
                  </h3>
                  <KYCDocumentsModal
                    show={showuploadKYC}
                    onHide={() => setModalShowUploadKYC(false)}
                  />
                </div>
                <div className="col d-flex justify-content-lg-end justify-content-between mt-2 mt-lg-0">
                  <button
                    className="btn blue_btn"
                    onClick={() => setModalShow(true)}
                  >
                    {" "}
                    Apply New Loan
                  </button>

                  <button
                    className="btn gray_btn ms-3"
                    onClick={() => setShow(true)}
                  >
                    Service Request
                  </button>
                </div>
              </div>

              <NewServiceRequest show={show} onHide={() => setShow(false)} />
              <ApplyNewLoan
                show={modalShow}
                onHide={() => setModalShow(false)}
              />

              <div className="">
                <div className="d-flex  justify-content-lg-start gap-5 mb-3 justify-content-between">
                  <div className="d-flex gap-3 me-5">
                    <div>
                      <img src="./images/icons/bars_icon.svg" alt="true" />
                    </div>
                    <div className="bd_amt_styl">
                      <b>Current Outstanding</b>
                      <br />
                      <span>
                        BHD{" "}
                        {isNaN(dashBoardData.total_outstanding_principal_bhd)?0:Number(
                          dashBoardData.total_outstanding_principal_bhd
                        ).toLocaleString()}
                      </span>{" "}
                      &nbsp;
                      <span>| </span>
                      <span>
                        ${" "}
                        {isNaN(dashBoardData.total_outstanding_principal_usd)?0:Number(
                          dashBoardData.total_outstanding_principal_usd
                        ).toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex gap-3 mr-lg-5 mr-0">
                    <div>
                      <img src="./images/icons/currency_icon.svg" alt="true" />
                    </div>
                    <div className="bd_amt_styl">
                      <b>Repayment Performance</b>
                      <br />
                      <span style={{ color: "#baa38b" }}>
                        {dashBoardData.repayment_performance ==='' || dashBoardData.repayment_performance=== undefined || dashBoardData.repayment_performance=== null ? '0' : dashBoardData.repayment_performance }%
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row d-flex mb-lg-4  bus_dashboard_width">
                  <div className=" col card shadow-ben db_cos_card_main me-lg-4 me-xxl-5 mb-3">
                    <div className="p-3 card_title_txt">
                      <article>
                        Current Outstanding Summary
                        <span
                          className="float-end bd_viewall"
                          onClick={() => navigate("/myloans")}
                        >
                          View All
                          <img
                            style={{ width: "10px" }}
                            className="ms-2"
                            src="./images/right_arrow.svg"
                            alt=""
                          />
                        </span>
                      </article>
                      <div className="bd_COS_div ">
                        {dashBoardData.current_outstanding?.map((i, index) => {
                          return (
                            <>
                              <div
                                className="row COS_card_styl mt-1"
                                key={index}
                              >
                                <span className="col text-start fw-bold ">
                                  {i.loan_type_name}
                                </span>
                                <span className="col-lg-3 text-end db_cos_curncy mb-2 me-3 inline-block">
                                  {"BHD" +" "+ i.total_outstanding_principal_bhd_type}
                                </span>
                                <span className="col text-end db_cos_curncy me-3">
                                   {"$"+Number(i.total_outstanding_principal_usd_type).toLocaleString()}
                                </span>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                    <div className="db_first_card_footer">
                    <div className="db_hr_polygon_div">
                      <p className="gray_border"></p>
                      <img src="./images/sesame_polygon.svg" alt="" />
                    </div>

                   
                      <div className=" card_footer_color p-2 ps-3 pe-3 row d-flex justify-content-between ">
                        <div className="col totl_repaid_div">
                          <span className="totl_repaid">Total Principal Repaid </span>
                         
                          <span>
                            <b className="">
                              {" "}
                              $&nbsp;{Number(dashBoardData.total_principal_repaid_usd).toLocaleString()}
                            </b>
                          </span>
                        </div>
                        <span className="col mt-1 totl_outstng">
                          Principal Outstanding Amount
                        </span>
                        <div className="col-lg-3 text-end">
                          <span>
                            <strong className="me-3 TOA">
                              {" "}
                              {dashBoardData.total_outstanding_principal_usd !==
                              undefined
                                ? "$ " +
                                  Number(dashBoardData.total_outstanding_principal_usd).toLocaleString()
                                : ""}
                            </strong>
                          </span>
                        </div>
                        <div className="mb-2 mt-2">
                          <ProgressBar
                            bgColor="#BAA38B"
                            baseBgColor="#3D79F3"
                            height="6px"
                            width="100%"
                            completed={isNaN(progress_usd)?0:progress_usd}  
                            customLabel=" "
                          />
                        </div>
                      </div>
                      <hr className="db_hr_styl" />
                      <div className=" card_footer_color p-2 ps-3 pe-3 row d-flex justify-content-between">
                        <div className="col totl_repaid_div">
                          <span className="totl_repaid">Total Principal Repaid </span>
                          &nbsp;
                          <span>
                            <b className="totlrepaidamt">
                              BHD&nbsp;{Number(dashBoardData.total_principal_repaid_bhd).toLocaleString()}
                            </b>
                          </span>
                        </div>
                        <span className="col mt-1 totl_outstng">
                          Principal Outstanding Amount
                        </span>
                        <div className="col-lg-3 text-end">
                          <span>
                            <strong className="me-3 TOA">
                              {dashBoardData.total_outstanding_principal_bhd !==
                              undefined
                                ? "BHD " +
                                 Number( dashBoardData.total_outstanding_principal_bhd).toLocaleString()
                                : ""}
                            </strong>
                          </span>
                        </div>
                        <div className="mb-2 mt-2">
                          <ProgressBar
                            bgColor="#BAA38B"
                            baseBgColor="#3D79F3"
                            height="6px"
                            width="100%"
                            completed={isNaN(progress_bhd)?0:progress_bhd}
                            customLabel=" "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col  p-3 card  shadow-ben card_title_txt mb-3 bd_cos_title">
                    <article>
                      Upcoming Loan Payments
                      <span
                        className="float-end bd_viewall"
                        onClick={() => navigate("/myloans")}
                      >
                        View All
                        <img
                          style={{ width: "10px" }}
                          className="ms-2"
                          src="./images/right_arrow.svg"
                          alt=""
                        />
                      </span>
                    </article>
                    <div className="inner_card_cont">
                    
                      {dashBoardData.upcoming_payments?.length===0? 
                        <NoData />
                       :dashBoardData.upcoming_payments?.map((i, index) => {
                        const number = i.upcoming_payments_percentage;
                        const perCent = number.toString();
                        return (
                          <div className="innercard_content" key={index}>
                            <div className="col-lg-2">
                              <h5>
                                {moment(i.tenure_date).format("DD MMM YYYY")}
                              </h5>
                              <p className="pt-1">
                                {i.admin_request_loan_currency ===
                                LOAN_CURRENCY_TYPE_USD
                                  ? "$ " + Number(i.tenure_amount).toLocaleString()
                                  : "BHD " + Number(i.tenure_amount).toLocaleString()}
                              </p>
                            </div>

                            
                            <div className="col pt-1">
                              <div
                                className="progress ben_progress_bar_main"
                                role="progressbar"
                                aria-label="upcoming_loan_payemnts"
                                aria-valuenow={i.upcoming_payments_percentage !== undefined ? i.upcoming_payments_percentage : '0' }
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                <div
                                  className="progress-bar ben_progress_bar"
                                  style={{ width: i.upcoming_payments_percentage !== undefined ? perCent+"%" : '0%' }}
                                ></div>
                              </div>
                            </div>


                            <div className="col ">
                              <h5>{i.loan_type_name}</h5>
                              <p className="pt-1">
                                Principal -{" "}
                                {i.admin_request_loan_currency !== undefined &&
                                i.admin_request_loan_currency ===
                                  LOAN_CURRENCY_TYPE_USD
                                  ? `$ ${
                                      i.loan_amount !== undefined
                                        ?Number( i.loan_amount).toLocaleString()
                                        : "-"
                                    }`
                                  : `BHD ${
                                      i.loan_amount !== undefined
                                        ? Number(i.loan_amount).toLocaleString()
                                        : "-"
                                    }`}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="row d-flex justify-content-between bus_dashboard_width">
                  <div className="col p-3 card  shadow-ben me-lg-4 me-xxl-5 card_title_txt bus_db_secondrowcard_height mb-3">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <img
                          className="mb-2 me-2"
                          src="./images/icons/currency_notes.svg"
                          alt=""
                        />
                        <article>Recent Repayments</article>
                      </div>
                    </div>

                    <div className="dash_b_RRP_table_div">
                      <Table className="db_rp_table">
                        <thead>
                          <tr className="db_sesame_table_title">
                            {dashBoardData.recent_repayments =='' ? <NoData />: columns.map((column) => (
                              <th key={column.field}>{column.title}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {dashBoardData.recent_repayments?.map((i, index) => (
                            <tr key={index}>
                              <td>{i.transaction_reference_no}</td>
                              <td>
                                {i.paid_currency == LOAN_CURRENCY_TYPE_USD
                                  ? "$" + " " + Number(i.paid_amount).toLocaleString()
                                  : i.paid_currency + " " + Number(i.paid_amount).toLocaleString()}
                              </td>
                              <td>
                                {moment(i.due_date).format("DD MMM YYYY")}
                              </td>
                              <td>
                                {moment(i.paid_date).format("DD MMM YYYY")}
                              </td>
                              <td>
                                {i.is_tenure_both_principal_interest === 1
                                  ? "Principal & Interest"
                                  : i.paid_principal === i.paid_amount
                                  ? "Principal"
                                  : i.paid_principal !== i.paid_amount
                                  ? "Interest"
                                  : i.is_tenure_both_principal_interest ===
                                    undefined
                                  ? "-"
                                  : i.is_tenure_both_principal_interest}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="col card shadow-ben  me-l mb-3 p-3 bus_db_secondrowcard_height  card_title_txt ">
                    <article>Type of Facility </article>
                    <div className=" ">
                     {dashBoardData.type_of_facility?.length===0? 
                        <NoData /> :  <div className="d-flex justify-content-between">
                        <div className="col-lg-5 doughnut_div"
                          style={{ height: "168px", width: "168x" }}
                        >
                          <Doughnut
                            data={chartData}
                            options={{
                              plugins: {
                                tooltip: false,
                                datalabels: {
                                  formatter: function (context) {
                                    return context + "%";
                                  },
                                  display: true,
                                  color: "white",
                                  font: {
                                    size: 11,
                                  },
                                },

                                // legend: {
                                //   position: "bottom",
                                //   align: "start",
                                //   display: false,
                                //   textDirection: "underline",
                                // },
                              },
                            }}
                          />
                        </div>
                        <div className="col d-flex flex-column typ_of_feclty_labels ms-2 me-1">
                          {dashBoardData.type_of_facility?.map((i, index) => {
                            return( <span className="d-flex  row " key={index}>
                                <div
                                  className="percent_first col-md-3 pt-md-2 pt-0"
                                  style={{ color: i.color_idx }}
                                >
                                  {i.percentage}%
                                </div>
                                <div className="inv_db_txt col pt-2 mt-1 ">
                                  {" "}
                                  {i.loan_type_name}
                                </div>
                              </span>)
                            
                            
                          })}
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center fw-bolder">
                For any queries, please contact support@bennefin.com
              </div>
            </div>
          )}
        </main>

        
        


      </div>
    );
  }
}
export default BusinessDashboard;

 

const NoData = () => {
  return (
    <div className="nodataStyl">No Data</div>
  );
};

 